import { LowerCasePipe, NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RiderColor } from '@polaris-customerweb/sharedcomponents.core';

@Component({
    imports: [NgClass, LowerCasePipe],
    selector: 'rdx-color-picker',
    styleUrls: ['./color-picker.component.scss'],
    templateUrl: './color-picker.component.html',
})
export class ColorPickerComponent {
    @Input() flexLayout: boolean;
    @Input() initialColor: RiderColor | null;
    @Input() id?: string;
    @Output() colorChanged = new EventEmitter<RiderColor>();

    colorChoices: RiderColor[] = [
        'Red',
        'Salmon',
        'Orange',
        'Gold',
        'Green',
        'DarkGreen',
        'Blue',
        'DarkBlue',
        'Purple',
        'Brown',
    ];

    changeColor(color: RiderColor) {
        this.colorChanged.emit(color);
    }
}
